import React from 'react';
import {
  CalculatorTwoTone,
  CalendarTwoTone,
  CarryOutTwoTone,
  CheckCircleTwoTone,
  CheckSquareTwoTone,
  DownSquareTwoTone,
  EditTwoTone,
  EuroCircleTwoTone,
  FileAddTwoTone,
  FileTextTwoTone,
} from '@ant-design/icons';

const tone = '#2748d9';

/** Question types, in the order the type picker shows them. `value` is the backend field_type. */
export const FIELD_TYPES = [
  { value: 'varchar', label: 'Short text', hint: 'One line, up to 255 characters', icon: <EditTwoTone twoToneColor={tone} /> },
  { value: 'text', label: 'Long text', hint: 'Several lines', icon: <FileTextTwoTone twoToneColor={tone} /> },
  { value: 'int', label: 'Whole number', hint: 'Numbers without decimals', icon: <CalculatorTwoTone twoToneColor={tone} /> },
  { value: 'decimal', label: 'Decimal number', hint: 'Numbers with two decimals', icon: <EuroCircleTwoTone twoToneColor={tone} /> },
  { value: 'date', label: 'Date', hint: 'A date picker', icon: <CalendarTwoTone twoToneColor={tone} /> },
  { value: 'boolean', label: 'Yes / No', hint: 'One tick box', icon: <CheckSquareTwoTone twoToneColor={tone} /> },
  { value: 'select', label: 'Dropdown', hint: 'Pick one from a list', icon: <DownSquareTwoTone twoToneColor={tone} /> },
  { value: 'radio', label: 'Radio buttons', hint: 'Pick one, all options shown', icon: <CheckCircleTwoTone twoToneColor={tone} /> },
  { value: 'checkbox', label: 'Checkboxes', hint: 'Pick several', icon: <CarryOutTwoTone twoToneColor={tone} /> },
  { value: 'file', label: 'File upload', hint: 'One file, with type and size limits', icon: <FileAddTwoTone twoToneColor={tone} /> },
];

export const typeOf = (value) => FIELD_TYPES.find((t) => t.value === value) || FIELD_TYPES[0];

export const CHOICE_TYPES = ['select', 'radio', 'checkbox'];
export const isChoice = (type) => CHOICE_TYPES.includes(type);

export const truthy = (v) => v === true || v === 1 || v === '1';

/** "Full name (as on ID)" -> "full_name_as_on_id", the shape the backend accepts for field_name. */
export const toFieldName = (label) => {
  const base = (label || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 60);
  if (!base) return '';
  return /^[a-z_]/.test(base) ? base : `q_${base}`;
};

export const FIELD_NAME_PATTERN = /^[a-z_][a-z0-9_]*$/;

/** Option labels are matched to workshop capacity after normalising spaces, as the backend does. */
export const normalizeLabel = (label) => String(label).replace(/[   ⁠　﻿]/g, ' ').trim();

/** snake_case to "Title Case", as the public page labels questions without a display label. */
export const formatFieldName = (fieldName) =>
  (fieldName || '')
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

export const questionTitle = (field) => field.display_label || formatFieldName(field.field_name) || 'Untitled question';
